import React from 'react'
import styled from 'styled-components'
import { colors } from '@giphy/react-giphy-brand'
import { mobile } from 'shared/util/media-query'

const socialColors = {
    facebook: colors.facebookColor,
    twitter: colors.twitterColor,
    tumblr: colors.tumblrColor,
    instagram: colors.instagramColor,
}

const Container = styled.div`
    padding-top: 5px;
    ${mobile.css`
        padding: 0;
        margin-bottom: 6px;
        a {
            margin-bottom: 0;
        }
    `}
`

const FollowLabel = styled.p`
    color: ${colors.giphyLightGrey};
    font-weight: 600;
    font-size: 14px;
    margin: 0 0 10px;
    -webkit-font-smoothing: antialiased;
`

const SocialButton = styled.a<{ name: string }>`
    height: 30px;
    width: 30px;
    display: inline-block;
    margin-bottom: 8px;
    margin-right: 8px;
    padding: 7px;
    color: ${props => socialColors[props.name]};
`

type SocialLink = {
    type: string
    url: string | undefined
}

type Props = {
    links: SocialLink[]
    isCompact: boolean | undefined
}

const Social = ({ links, isCompact }: Props) => (
    <Container>
        {!isCompact && <FollowLabel>Follow on:</FollowLabel>}
        {links.map(({ type, url }) => (
            <SocialButton
                key={type}
                className={`ss-social ss-${type}`}
                rel="noopener noreferrer"
                href={url}
                target="_blank"
                name={type}
            />
        ))}
    </Container>
)

export default Social
